
const baseUrl = () => {
   console.log("Checking Environment");
   console.log(process.env.NODE_ENV);
   console.log(process.env.VUE_APP_APIENDPOINT);
   return process.env.VUE_APP_APIENDPOINT;
}

const displayCityAndStreetCodeOnly = true;
const logger = {

   loggerEndPoint : baseUrl() + "/logger/save/",
   enableLog : true,
   interval:{
      minutes: '/10', //For formats check docs of Vue-Crontab
      // seconds: '/30',
   }
}

const dependency = {
   showByDefault : false
}
let updateAvailable = false;
const surveyResponse = {
   questionaireKey : "questionaire",
   survaySaveKey:"surveyResponseStore",
    apiEndpoint: `${baseUrl()}/pushResponse`

}
const websqlDb = {
   dbName:"ayalon.db",
   dbDisplayName:"ayalon_db",
   version:"1.0",
   estimatedSize:50 * 1024 * 1024,
   dbClearDays:7
}
const user = {
   saveEndpoint : `${baseUrl()}/saveSurveyor`,
   excludeGovId : `${baseUrl()}/excludeGovId`,
   defaultGovId : `000000000`
}
export default {
   baseUrl, displayCityAndStreetCodeOnly,logger, dependency, updateAvailable, surveyResponse, websqlDb, user
}
